import styled from 'styled-components';
import { makeStyles, styled as materialStyled } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  product: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: '16px 16px 0 0',
    width: 140,
    height: 64,
    transition: 'all 0.2s',
    filter: 'grayscale(100%)',
    margin: '9px 4px 0 4px',
    display: 'flex',
    justifyContent: 'center',

    '& div': {
      display: 'flex',
      alignItems: 'center',
    },

    '&:hover': {
      filter: 'grayscale(0%)',
      backgroundColor: '#fff',
    },
  },
  productActive: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: '16px 16px 0 0',
    backgroundColor: '#fff',
    marginTop: 9,
    width: 140,
    height: 64,
    display: 'flex',

    '& div': {
      display: 'flex',
      alignItems: 'center',
    },

    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export const Container = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0;
`;
